module.exports = __webpack_public_path__ + "img/header-2.3869be63.png";